<template>
  <div class="admins-panel">
    <stihl-flag :message="$t('adm.page.organization.flagAdmins')" />
    <div class="row row-cols-3 admins">
      <div class="col admin" v-for="admin in admins" :key="admin.id">
        <img
          src="@/assets/img/icons/primary-contact.svg"
          :alt="$t('adm.label.primaryContact')"
          :title="$t('adm.label.primaryContact')"
          v-if="primaryContact === admin.id">
        <a @click="$emit('userClick', admin.id)" @keyup.space="$emit('userClick', admin.id)">
          {{ admin.firstname }} {{ admin.lastname }}
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import StihlFlag from '@/components/ui/StihlFlag.vue';
import { AdminDTO } from '@/components/backend';

export default defineComponent({
  name: 'AdminsPanel',
  components: { StihlFlag },
  emits: ['userClick'],
  props: {
    primaryContact: { type: String, default: null },
    admins: { type: Array as PropType<AdminDTO[]>, default: new Array<AdminDTO>() },
  },
});
</script>

<style>
:root {
  --stihl-admins-max-height: 30rem;
}

.admins-panel .row.admins {
  --bs-gutter-x: 0;
  max-height: var(--stihl-admins-max-height);
  overflow: auto;
  background-color: var(--grey-light);
}

.admins-panel .admins .admin {
  display: flex;
  gap:.5rem;

  height: 3rem;
  padding: 0.5rem 1rem;
  align-items: center;

  border-right: 1px solid var(--grey-base);
}

.admins-panel .admins .admin:nth-child(3n+3) {
  border-right: 0;
}

.admins-panel .admins .admin a {
  color: var(--blue-dark) !important;
  text-decoration: underline !important;
  font-feature-settings: 'clig' off, 'liga' off;

  font-size: 1rem;
  line-height: 1rem;
}

.admins-panel .admins .admin a:hover {
  cursor: pointer;
  text-decoration: underline;
}
</style>
